import { defineMessages } from 'react-intl'

export const auEvergreenPageTitles = defineMessages({
  shop: {
    id: '_vcJZeJHEe1qf9obbVuo',
    defaultMessage: 'Luxury Escapes Shop - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes merchandise shop landing page',
  },
  'lux-plus': {
    id: 'B_YlRa2zVWhfPdLuJzyn',
    defaultMessage: 'LuxPlus+ Membership - Luxury Escapes AU',
    description: 'SEO title for the Australian LuxPlus paid membership landing page',
  },
  'affiliate-program': {
    id: 'EqnInJ_DM57MIK45a986',
    defaultMessage: 'Affiliate Program - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes affiliate program landing page',
  },
  support: {
    id: 'nbhl3OUN33SgJok22AFe',
    defaultMessage: 'Help & Support - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes customer support landing page',
  },
  weddings: {
    id: '233vGJLPW8uvuMDiMGM6',
    defaultMessage: 'Luxury Weddings - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes destination weddings landing page',
  },
  flights: {
    id: 'MZXQlp8wos5TFz55dg2e',
    defaultMessage: 'Luxury Escapes Flights - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes flights landing page',
  },
  societe: {
    id: 'ONhaNp9Xw-7OpTsclcQ-',
    defaultMessage: 'Luxury Escapes Membership | Société',
    description: 'SEO title for the Australian Société loyalty membership landing page',
  },
  experiences: {
    id: '4IxDAJ_GiY1hOkfsto1d',
    defaultMessage: 'Luxury Experiences - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes experiences landing page',
  },
  'car-hire': {
    id: 'LPq5NBzWh_ZaWaGMyX0d',
    defaultMessage: 'Car Hire - Luxury Escapes AU',
    description: 'SEO title for the Australian Luxury Escapes car hire landing page',
  },
})

export const auEvergreenPageHeadings = defineMessages({
  shop: {
    id: 'Jw-0EF8gAx4DdGx6pCMm',
    defaultMessage: 'Shop',
    description: 'Primary semantic heading for the Australian merchandise shop landing page',
  },
  'lux-plus': {
    id: 'PuEsS21JZA5c47HEpp4q',
    defaultMessage: 'LuxPlus+',
    description: 'Primary semantic heading for the Australian LuxPlus paid membership landing page',
  },
  'affiliate-program': {
    id: 'vFH78-ojzTtrQekjpHIV',
    defaultMessage: 'Affiliate program',
    description: 'Primary semantic heading for the Australian affiliate program landing page',
  },
  support: {
    id: 'TClfQnowY0JCcqXuVT_l',
    defaultMessage: 'Help & Support',
    description: 'Primary semantic heading for the Australian customer support landing page',
  },
  weddings: {
    id: '7Iyc9m9qC3Lmxum8CR-j',
    defaultMessage: 'Weddings',
    description: 'Primary semantic heading for the Australian destination weddings landing page',
  },
  flights: {
    id: 'ByQAy_9lga2C8rDwT--c',
    defaultMessage: 'Flights',
    description: 'Primary semantic heading for the Australian flight booking landing page',
  },
  societe: {
    id: 'Vf7HqpyIdR1HmTV0u2nm',
    defaultMessage: 'Société',
    description: 'Primary semantic heading for the Australian Société loyalty membership landing page',
  },
  experiences: {
    id: 'NQYZ7_QfTBV_I8Oo9X4U',
    defaultMessage: 'Experiences',
    description: 'Primary semantic heading for the Australian experiences booking landing page',
  },
  'car-hire': {
    id: 'XG1oe5NogsPZQaT9SDk_',
    defaultMessage: 'Car hire',
    description: 'Primary semantic heading for the Australian car hire booking landing page',
  },
})
